export const isValuePresent = (value) => (
    value !== null
    && value !== undefined
    && value !== ''
    && !(typeof value === 'number' && Number.isNaN(value))
);

export const isJSON = (value) => {
    try {
        JSON.parse(value);

        return true;
    } catch (e) {
        return false;
    }
};
